"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ALLERGY_MAX_ITEMS () {
        return ALLERGY_MAX_ITEMS;
    },
    get ALLERGY_MAX_LENGTH () {
        return ALLERGY_MAX_LENGTH;
    },
    get CIVIL_STATUS_LABELS () {
        return CIVIL_STATUS_LABELS;
    },
    get CivilStatusSchema () {
        return CivilStatusSchema;
    },
    get EmergencyContactSchema () {
        return EmergencyContactSchema;
    },
    get NO_KNOWN_ALLERGIES_CONFLICT_MESSAGE () {
        return NO_KNOWN_ALLERGIES_CONFLICT_MESSAGE;
    },
    get PatientAllergiesSchema () {
        return PatientAllergiesSchema;
    },
    get PatientCreateRequestSchema () {
        return PatientCreateRequestSchema;
    },
    get PatientCreateResponseSchema () {
        return PatientCreateResponseSchema;
    },
    get checkNoKnownAllergies () {
        return checkNoKnownAllergies;
    }
});
const _zod = require("zod");
const _patientfields = require("./patient-fields");
const CivilStatusSchema = _zod.z.enum([
    'single',
    'married',
    'widowed',
    'separated',
    'annulled'
]);
const CIVIL_STATUS_LABELS = {
    single: 'Single',
    married: 'Married',
    widowed: 'Widowed',
    separated: 'Separated',
    annulled: 'Annulled'
};
const ALLERGY_MAX_ITEMS = 20;
const ALLERGY_MAX_LENGTH = 100;
const PatientAllergiesSchema = _zod.z.array(_zod.z.string().trim().min(1, {
    error: 'Allergy cannot be blank.'
}).max(ALLERGY_MAX_LENGTH, {
    error: `Allergy must be at most ${String(ALLERGY_MAX_LENGTH)} characters.`
})).max(ALLERGY_MAX_ITEMS, {
    error: `At most ${String(ALLERGY_MAX_ITEMS)} allergies.`
}).transform((items)=>{
    const seen = new Set();
    return items.filter((item)=>{
        const key = item.toLowerCase();
        if (seen.has(key)) {
            return false;
        }
        seen.add(key);
        return true;
    });
}).default([]);
const NO_KNOWN_ALLERGIES_CONFLICT_MESSAGE = 'Clear the listed allergies or untick No known allergies.';
function checkNoKnownAllergies(value, ctx) {
    if (value.noKnownAllergies !== true) {
        return;
    }
    if (!Array.isArray(value.allergies) || value.allergies.length === 0) {
        return;
    }
    ctx.addIssue({
        code: 'custom',
        path: [
            'noKnownAllergies'
        ],
        message: NO_KNOWN_ALLERGIES_CONFLICT_MESSAGE
    });
}
const EmergencyContactSchema = _zod.z.object({
    name: (0, _patientfields.requiredName)(150, 'Contact name'),
    relationship: (0, _patientfields.requiredName)(50, 'Relationship'),
    mobile: (0, _patientfields.phMobile)('Contact mobile')
}).strict();
const PatientCreateRequestSchema = _zod.z.object({
    givenName: (0, _patientfields.requiredName)(100, 'Given name'),
    middleName: (0, _patientfields.optionalText)(100, 'Middle name'),
    familyName: (0, _patientfields.requiredName)(100, 'Family name'),
    birthDate: _patientfields.birthDate,
    sex: _zod.z.enum([
        'F',
        'M'
    ], {
        error: 'Select a sex.'
    }),
    mobile: (0, _patientfields.phMobile)('Mobile number'),
    civilStatus: CivilStatusSchema.optional(),
    address: (0, _patientfields.optionalText)(300, 'Address'),
    philhealthPin: _patientfields.optionalPhilhealthPin,
    philsysNumber: _patientfields.optionalPhilsysNumber,
    alerts: _patientfields.alerts,
    allergies: PatientAllergiesSchema,
    noKnownAllergies: _zod.z.boolean({
        error: 'Select whether the patient has no known allergies.'
    }).default(false),
    emergencyContact: EmergencyContactSchema.optional(),
    firstEncounter: _zod.z.boolean({
        error: 'Select first encounter or returning patient.'
    })
}).strict().superRefine((request, ctx)=>{
    if (request.firstEncounter && request.philhealthPin === undefined) {
        ctx.addIssue({
            code: 'custom',
            path: [
                'philhealthPin'
            ],
            message: 'PhilHealth PIN is required for a first encounter.'
        });
    }
    checkNoKnownAllergies(request, ctx);
});
const PatientCreateResponseSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    mrn: _zod.z.string()
});
